import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { ResourcesSection } from '../components/ResourcesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="w-full min-h-screen bg-white" data-id="element-340">
      <Navbar data-id="element-341" />
      <HeroSection data-id="element-342" />
      <AboutSection data-id="element-343" />
      <ServicesSection data-id="element-344" />
      <ResourcesSection data-id="element-345" />
      <TestimonialsSection data-id="element-346" />
      <ContactSection data-id="element-347" />
      <Footer data-id="element-348" />
    </div>;
}